__turbopack_context__.v({
  "className": "_8eSXSa_className",
  "variable": "_8eSXSa_variable",
});
